import { DefaultService } from '@/services/DefaultService';

export default class RelatorioKmAutomaticoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}


	find(id) {
		return this._http.get(`${this._env}/despesa/relatorio/kmautomatico/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAll(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/despesa/relatorio/kmautomatico.json?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}

    /**
     * @70209 - implementado esse metodo para pegar o valor total das despesas.
     */
    getValorTotal(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/despesa/relatorio/kmautomatico/valortotal?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}

    /**
     * 70209 - Criado essa funcao para pegar os km automaticos pela tabela asscheckdespesa.
     */
    findAllByAss(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/despesa/relatorio/kmsautomatico.json?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}

	findAllExport(filter) {
        let headCopy = { ...this._headers};
        headCopy.responseType = 'arraybuffer';
        return this._http.post(`${this._env}/despesa/relatorio/kmautomatico/pdf`, filter, headCopy)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
	}
	filtroEmpresas() {
        return this._http.get(`${this._env}/despesa/relatorio/kmautomatico/filtro/empresas.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
	filtroColaboradores() {
        return this._http.get(`${this._env}/despesa/relatorio/kmautomatico/filtro/colaboradores.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
	filtroMotivoDespesas() {
        return this._http.get(`${this._env}/despesa/relatorio/kmautomatico/filtro/motivodespesas.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
    
    getCSVReport(filtros) {
        return this._http.post(`${this._env}/despesa/relatorio/kmautomatico/csv`, filtros, this._headers).then( res => res.body, this.handleError);
    }

}